// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4ab2bc92e61ce1cd1713","655":"d8fbcf8c3a5a65bd1ae6"}[chunkId] + ".js";
};